const scene = "gst/";

export const UPDATE_GST = `${scene}UPDATE_GST`;